module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1269.e2b873dc.png";